(function() {
    $(document).ready(function() {
        basketCounterManger.init();
    });
    $(document).on('basketUpdated', function () {
        basketCounterManger.init();
    });
    const basketCounterManger = {
        el: null,
        init: function() {
            this.el = $('.menu-BasketH');

            let count = parseInt(this.getStoredValue() || '0');
            this.refreshBasketCounter(count);
        },
        refreshBasketCounter: function(count) {
            this.el.find('#totalItem').remove();
            if (count > 0) {
                if (!this.el.find('.counter').length) {
                    this.el.find('img').wrap('<span class="counter"></span>');
                }
                this.el.find('.counter').append('<span id="totalItem">' + count + '</span>');
            }
        },
        getStoredValue: function() {
            let result = document.cookie.match('(^|;) ?basket-count=([^;]*)(;|$)');
            return result ? result[2] : null;
        }
    };
})();
function putPromotionTagBack($this, html, $refClass = '', $html = '', refIconClass = '') {
    $this.html(html);
    if ($html != '') {
        $refClass.html($html);
    }
    if (refIconClass != '') {
        requestAnimationFrame(() => {
            const newRef = $this.find(refIconClass);
            newRef.focus();
        });
    }
}
$(document).ready(function() {
    $(document).on('click', '.putTagCopy', function() {
        let $this = $(this);
        let oldHtml = $('.tagCopy' + $this.attr('data-ref')).html();
        let imgSrc = "/img/tick.svg";
        let imgAlt = $this.attr('data-attr-copy');
        let img = new Image();
        img.src = imgSrc;
        img.onload = function() {
            $('.tagCopy' + $this.attr('data-ref')).html('\
                <i class="fa fa-info-circle promoInfoTopPicks" aria-hidden="true" data-target="' + $this.attr('data-modal-info') + '" data-open-info="' + $this.attr('data-ref-open') + '"></i>\
                <span class="promoTextTopPicks">' + $this.attr('data-short-name') + '\
                    COPIED\
                    <img class="promoCopiedTopPicks" title="Promotion code copied" src="' + imgSrc + '" alt="' + imgAlt + '">\
                </span>\
            ');
        };
        setTimeout(putPromotionTagBack, 4500, $('.tagCopy' + $this.attr('data-ref')), oldHtml);
    });
    $(document).on('click', '.putTagModalCopy', function() {
        let $this = $(this);
        let oldHtml = $this.html();
        let imgSrc = "/img/tick.svg";
        let imgAlt = $this.attr('data-attr-copy');
        let imgCls = $this.attr('data-ref-image-cls') ? $this.attr('data-ref-image-cls') : '';
        let img = new Image();
        img.src = imgSrc;
        img.onload = function() {
            $this.html('\
                <span class="promoCopyText promoCopyTextVAM">COPIED</span>\
                <img class="promoCopiedModal ' + imgCls + '" title="Promotion code copied" src="' + imgSrc + '" alt="' + imgAlt + '">\
            ');
        };
        setTimeout(putPromotionTagBack, 4500, $this, oldHtml);
    });
    $(document).on('click', '.putTagCopySimo', function() {
        let $this = $(this);
        let refClass = '.tagCopySimo' + $this.attr('data-ref');
        let oldHtml = $(refClass).html();
        let imgSrc = "/img/tick.svg";
        let imgAlt = $this.attr('data-attr-copy');
        let shortName = $this.attr('data-short-name');
        let img = new Image();
        img.src = imgSrc;
        img.onload = function() {
            $(refClass).html(shortName + '\
                COPIED\
                <span class="promoCopiedSimo">\
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <rect width="20" height="20" fill="white" fill-opacity="0.01"></rect>\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1363 6.33788C17.336 6.53387 17.336 6.85564 17.1363 7.05164L8.60195 15.426C8.41558 15.6089 8.11987 15.6175 7.9231 15.4459L2.88396 11.0507C2.67308 10.8667 2.65419 10.5455 2.84205 10.3382L4.51144 8.49532C4.69437 8.29338 5.00531 8.27509 5.21066 8.4542L8.12949 11.0001L14.6583 4.59363C14.8528 4.4028 15.1643 4.4028 15.3587 4.59363L17.1363 6.33788Z" fill="white"></path>\
                    </svg>\
                </span>\
            ');
        };
        setTimeout(putPromotionTagBack, 4500, $(refClass), oldHtml);
    });
    $(document).on('click', '.putTagModalIconCopy', function() {
        let $this = $(this);
        let oldHtml = $this.html();
        let imgSrc = "/img/tick.svg";
        let imgAlt = $this.attr('data-attr-copy');
        let img = new Image();
        img.src = imgSrc;
        img.onload = function() {
            $this.html('\
                <span class="promoCopyText promoCopyTextVAM">COPIED</span>\
                <img class="promo-copyIcon promoCopiedModal" title="Promotion code copied" src="' + imgSrc + '" alt="' + imgAlt + '">\
            ');
        };
        setTimeout(putPromotionTagBack, 4500, $this, oldHtml);
    });
    $(document).on('click', '.copyPromoPdpHandset', function() {
        let $this = $(this);
        let refClass = '.tagCopySimo' + $this.attr('data-ref');
        let refIconClass = '.copyPromoPdpHandset' + $this.attr('data-ref');
        let oldHtml = $(refClass).html();
        $(refIconClass).html('\
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.88 7.617a.5.5 0 0 1 0 .718L10.196 18.682a.5.5 0 0 1-.675.02l-6.38-5.494a.5.5 0 0 1-.043-.717l2.21-2.409a.5.5 0 0 1 .695-.04l3.689 3.175 8.136-7.88a.5.5 0 0 1 .696 0l2.354 2.28z" fill="#fff"/>\
            </svg>\
        ');
        setTimeout(putPromotionTagBack, 4500, $(refClass), oldHtml, $(refIconClass), '', refIconClass);
    });
    $(document).on('click', '.promoCopyTopPicks, .copyPromoPdpHandset', function() {
        let copyText = $(this).attr('data-attr-copy');
        let clipBoardElem = document.createElement('textarea');
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = copyText;
        clipBoardElem.select();
        navigator.clipboard.writeText(clipBoardElem.value);
        document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
    });
    $(document).on('hide.bs.modal', '.promoModal', function () {
        const focusedElement = document.activeElement;
        // Check if the focused element is inside this modal
        if (this.contains(focusedElement)) {
            focusedElement.blur();
        }
    });
    $(document).on('click', '.promoCopy', function () {
        const copyText = $(this).attr('data-attr-copy');
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(copyText).catch(() => {
                fallbackCopy(copyText);
            });
        } else {
            fallbackCopy(copyText);
        }
        this.blur(); // Prevent Safari accessibility warning
    });
    function fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }
});
